import { IValidationResult, validResult } from '../ValidateEntry';
import { UI } from '../../../UI/UI';

export const ValidateEventVerb = (verb: string): IValidationResult => {
	var isEventVerbValid = UI.IsEventVerbValid(verb);
	if (!isEventVerbValid) {
		var validVerbs = UI.GetValidVerbs(verb);

		return {
			isValid: false,
			errorMessage: "The new entry's verb must be one of: " + validVerbs
		}
	}
	
    return validResult;
};
